<template>
  <div class="nd-page">
    <header class="nd-page-header">
      <div>
        <h1 id="title" class="page-title">Exames</h1>
        <p class="nd-page-kicker">Solicitações, laboratórios e documentos clínicos.</p>
      </div>
      <v-btn id="btnNew" type="button" color="primary" elevation="0" to="/exames/novo">
        <v-icon left small>mdi-plus</v-icon>
        Incluir
      </v-btn>
    </header>

    <module-stat-grid module="tests" :items="dataList.data" :count="dataList.count" />

    <v-card class="nd-section-card">
      <div class="nd-table-toolbar">
        <div>
          <div class="nd-table-toolbar__title">Exames</div>
          <div class="nd-table-toolbar__subtitle">Filtre e acompanhe solicitações laboratoriais.</div>
        </div>
        <v-form class="nd-table-toolbar__actions nd-table-toolbar__actions--wide" @submit.prevent="load()">
          <v-text-field
            dense
            id="laboratory"
            placeholder="Buscar laboratório"
            prepend-inner-icon="mdi-magnify"
            v-model="dataList.filter.laboratory" hide-details="auto"
            outlined
          ></v-text-field>
          <v-text-field dense id="patientName" placeholder="Paciente" v-model="dataList.filter.patientName" hide-details="auto" outlined></v-text-field>
          <v-text-field dense id="doctorName" placeholder="Médico" v-model="dataList.filter.doctorName" hide-details="auto" outlined></v-text-field>
          <v-btn id="btnFilter" type="submit" outlined color="primary" elevation="0">
            <v-icon left size="18">mdi-filter-outline</v-icon>
            Filtrar
          </v-btn>
        </v-form>
      </div>
            <v-data-table
              :headers="dataList.headers"
              :items="dataList.data"
              @update:items-per-page="pageSizeChanged"
              @update:page="pageChanged"
              :server-items-length="dataList.count"
              :disable-sort="true"
              :loading="dataList.loading"
              no-data-text="Nenhum exame encontrado"
              loading-text="Carregando dados..."
              class="app-table hover-table"
              :options.sync="dataList.options"
              :footer-props="dataList.footerOptions"
            >

              <template v-slot:[`item.laboratory`]="{ item }">
                <div class="nd-entity-cell">
                  <span class="nd-entity-mark">{{ item.laboratory && item.laboratory.name ? item.laboratory.name.charAt(0) : "E" }}</span>
                  <div>
                    <strong>{{ item.laboratory ? item.laboratory.name : '—' }}</strong>
                    <small>ID {{ item.id }}</small>
                  </div>
                </div>
              </template>

              <template v-slot:[`item.patient`]="{ item }">
                <div class="nd-entity-cell">
                  <span class="nd-entity-mark">{{ item.patient && item.patient.name ? item.patient.name.charAt(0) : "P" }}</span>
                  <div>
                    <strong>{{ item.patient ? item.patient.name : "—" }}</strong>
                    <small>{{ item.patient ? `ID ${item.patient.id}` : "Sem paciente" }}</small>
                  </div>
                </div>
              </template>

              <template v-slot:[`item.date`]="{ item }">
                {{ item.date ? new Date(item.date).toLocaleDateString('pt-BR') : '—' }}
              </template>

              <template v-slot:[`item.actions`]="{ item }">
                <div class="row-actions">
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn icon small v-on="on" @click="viewItem(item)">
                        <v-icon size="19">mdi-pencil-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Atualizar exame</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn icon small v-on="on" @click="deleteTest(item)">
                        <v-icon size="19">mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Remover exame</span>
                  </v-tooltip>

                </div>
              </template>
            </v-data-table>
    </v-card>
  </div>
</template>

<script>
import ModuleStatGrid from "@/components/ModuleStatGrid.vue";
import Vue from "vue";
import VueLodash from "vue-lodash";
import _ from "lodash";
import axios from "axios";

Vue.use(VueLodash, { lodash: _ });

export default {
  components: { ModuleStatGrid },
  name: "TestsList",

  data: () => ({
    dataset: {
      data: {},
    },
    dataList: {
      filter: {
        laboratory: "",
        patientName: "",
        doctorName: "",
      },
      headers: [
        { text: "Paciente", value: "patient" },
        { text: "Laboratório", value: "laboratory" },
        { text: "Médico", value: "doctorName" },
        { text: "Tipo", value: "type.name" },
        { text: "Status", value: "status" },
        { text: "Data", value: "date", sortable: false },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
      data: [],
      loading: false,
      count: 0,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ["id"],
        sortDesc: [false],
      },
      footerOptions: {
        itemsPerPageText: "Itens por página:",
        itemsPerPageOptions: [10, 20, 30, 40, 50],
        pageText: "{0}-{1} de {2}",
      },
    },
  }),

  created() {
    this.load();
  },

  computed: {
    lastRecordDate() {
      const latest = this.dataList.data.find((item) => item.date);
      return latest ? new Date(latest.date).toLocaleDateString("pt-BR") : "-";
    },
  },

  watch: {
    "dataList.data": {
      handler(newVal) {},
      deep: true,
      immediate: true,
    },
  },

  methods: {
    pageChanged(page) {
      this.dataList.options.page = page;
      this.load();
    },

    pageSizeChanged(size) {
      this.dataList.options.itemsPerPage = size;
      this.load(true);
    },

    async load() {
      const limit = this.dataList.options.itemsPerPage || 10;
      const params = {
        start: (this.dataList.options.page - 1) * limit,
        limit,
      };

      Object.entries(this.dataList.filter).forEach(([key, value]) => {
        if (value) params[key] = value;
      });

      this.dataList.loading = true;

      try {
        const result = await axios.get("/tests", {
          params: params,
        });

        this.dataList.data = result.data.data;
        this.dataList.count = result.data.count;
      } catch (error) {
        this.$dialog.notify.error(
          "Ocorreu um erro ao encontrar os exames, reinicie sua sessão e tente novamente!",
          {
            position: "top-right",
            timeout: 5000,
          }
        );
      } finally {
        this.dataList.loading = false;
      }
    },

    viewItem(item) {
      this.$router.push(`/exames/${item.id}`);
    },

    async deleteTest(item) {
      const proceed = await this.$dialog.confirm({
        text: `Deseja realmente remover o exame "${item.id}"?`,
        title: "Confirmar Exclusão",
        actions: {
          false: "Cancelar",
          true: { text: "Remover", color: "error" },
        },
      });

      if (proceed) {
        this.dataList.loading = true;
        try {
          await axios.delete(`/tests/${item.id}`);
          this.$dialog.notify.info(`Exame "${item.id}" removido com sucesso!`, {
            position: "top-right",
            timeout: 2000,
          });
          this.load();
        } catch (error) {
          console.error("Erro ao remover exame:", error);
          this.$dialog.notify.error(
            "Ocorreu um erro ao remover o exame. Tente novamente mais tarde.",
            {
              position: "top-right",
              timeout: 5000,
            }
          );
        } finally {
          this.dataList.loading = false;
        }
      }
    },
  },
};
</script>
